export const BaseUrl = "https://admin.saysha.in"